import React, { useEffect, useState } from 'react';

/**
 * A one-line notice at the bottom of the app ("Switched to Monte Carlo.").
 * Call showInkToast from anywhere; AppShell renders <InkToast />. It clears
 * itself after a few seconds or on Dismiss.
 */

type Listener = (text: string) => void;
const listeners = new Set<Listener>();

export function showInkToast(text: string) {
  listeners.forEach((fn) => fn(text));
}

export function InkToast() {
  const [text, setText] = useState('');
  const [key, setKey] = useState(0);

  useEffect(() => {
    const fn: Listener = (t) => {
      setText(t);
      setKey((k) => k + 1);
    };
    listeners.add(fn);
    return () => {
      listeners.delete(fn);
    };
  }, []);

  useEffect(() => {
    if (!text) return;
    const t = setTimeout(() => setText(''), 4500);
    return () => clearTimeout(t);
  }, [text, key]);

  if (!text) return null;
  return (
    <div className="ink-toast" role="status">
      {text}
      <button type="button" onClick={() => setText('')}>
        Dismiss
      </button>
    </div>
  );
}
